import { Pipe, PipeTransform } from '@angular/core';
import { IMultiPrintDevice } from '@multiprint/abstract/multi-print-device';

@Pipe({
  name: 'multiprintOnlyDevices'
})
export class MultiprintOnlyDevicesPipe implements PipeTransform {

  transform(value: IMultiPrintDevice[], only: string[]): IMultiPrintDevice[] {
    if (only.length === 0) {
      return value;
    }
    return value.filter(p => only.includes(p.id));
  }

}
